import {
  Component,
  Input,
} from '@angular/core';

@Component({
    selector: 'file-video-show-view',
    templateUrl: './file-video-show-view.component.html',
    styleUrls: ['./file-video-show-view.component.scss'],
})
export class FileVideoShowViewComponent {
    @Input() url: string = null;

    constructor(){}


}